/** ms → 'YYYY-MM-DD' v místním čase ('' = bez omezení). */
export function msToDen(ms: number | null | undefined): string {
  if (!ms) return '';
  const d = new Date(ms);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** 'YYYY-MM-DD' → začátek (00:00) nebo konec (23:59:59) dne v místním čase. */
export function denToMs(den: string, konec: boolean): number | null {
  if (!den) return null;
  const [y, m, d] = den.split('-').map(Number);
  if (!y || !m || !d) return null;
  return konec
    ? new Date(y, m - 1, d, 23, 59, 59, 999).getTime()
    : new Date(y, m - 1, d, 0, 0, 0, 0).getTime();
}

/**
 * Období platnosti nabídky (např. vánoční balení jen v listopadu a prosinci).
 * Prázdné políčko = bez omezení.
 */
export function OfferObdobi({
  od,
  do: doDen,
  onOd,
  onDo,
}: {
  od: string;
  do: string;
  onOd: (v: string) => void;
  onDo: (v: string) => void;
}) {
  const spatne = !!od && !!doDen && doDen < od;
  return (
    <div>
      <div className="text-sm font-medium text-text mb-1">Zobrazovat (volitelné)</div>
      <div className="flex flex-wrap items-center gap-2 text-sm text-text-secondary">
        od
        <input
          type="date"
          value={od}
          onChange={(e) => onOd(e.target.value)}
          className="rounded-lg border border-border bg-surface px-3 py-1.5 text-text focus:outline-none focus:border-primary"
        />
        do
        <input
          type="date"
          value={doDen}
          onChange={(e) => onDo(e.target.value)}
          className="rounded-lg border border-border bg-surface px-3 py-1.5 text-text focus:outline-none focus:border-primary"
        />
      </div>
      <p className={`mt-1 text-xs ${spatne ? 'text-danger' : 'text-text-muted'}`}>
        {spatne ? 'Konec musí být po začátku.' : 'Prázdné = bez omezení.'}
      </p>
    </div>
  );
}
